export default __webpack_public_path__ + "dia.css.liquid";